var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { useEffectWithoutCleanup, useState } from "GlobalShared/haunted/CustomHooks";
import { html } from "lit-html";
import { useAwesomeValidator, Validation } from "GlobalShared/validation/AwesomeValidator";
export const usePoARevokedModal = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [documentReference, setDocumentReference] = useState(void 0);
  const [dateOfRevocation, setDateOfRevocation] = useState(void 0);
  useEffectWithoutCleanup(() => __async(void 0, null, function* () {
    if (props && props.change) {
      setDocumentReference(props.change.DocumentId);
      setDateOfRevocation(props.change.DateOfRevocation);
    }
  }), [props]);
  const show = () => {
    setShowModal(true);
  };
  useEffectWithoutCleanup(() => {
    setDocumentReference(void 0);
    setDateOfRevocation(void 0);
  }, [showModal]);
  useEffectWithoutCleanup(() => {
    if (showModal) {
      validator.clear();
    }
  }, [showModal]);
  useEffectWithoutCleanup(() => {
    validator.validate({ DocumentId: documentReference, DateOfRevocation: dateOfRevocation });
  }, [documentReference, dateOfRevocation]);
  const validator = useAwesomeValidator(
    [Validation.ruleFor("DateOfRevocation", (vm) => vm.DateOfRevocation).isRequired()],
    () => props.save({ DocumentId: documentReference, DateOfRevocation: dateOfRevocation })
  );
  const template = html`${showModal ? html`<div>
				<dc-modal
					.visible=${showModal}
					@close=${() => setShowModal(false)}
					.header=${"VAT PoA Revocation"}
					.content=${html`<div class="space-y-4 md:w-1/2">
						<dc-fileupload
							.label=${"Confirmation"}
							.fileName=${void 0}
							.fileReference=${documentReference}
							@upload=${(e) => __async(void 0, null, function* () {
    var _a;
    if (((_a = e.detail) == null ? void 0 : _a.files) && e.detail.files.length > 0) {
      setDocumentReference(yield props.uploadDocument(e.detail.files[0]));
    }
  })}
						></dc-fileupload>
						<dc-datepicker
							.label=${"PoA revoked on*"}
							.value=${dateOfRevocation}
							.validationMessage=${validator.getMessage("DateOfRevocation")}
							@change=${(e) => {
    validator.showMessageFor("DateOfRevocation");
    setDateOfRevocation(e.detail.value);
  }}
						></dc-datepicker>
						<div class="mt-8">
							<button class="btn btn-primary mr-4" @click=${() => setShowModal(false)}>Cancel</button>
							<button
								class="btn btn-primary"
								?disabled=${dateOfRevocation === void 0}
								@click=${() => __async(void 0, null, function* () {
    validator.validateAndDispatch({
      DateOfRevocation: dateOfRevocation,
      DocumentId: documentReference
    });
    setShowModal(false);
  })}
							>
								Save
							</button>
						</div>
					</div>`}
				>
				</dc-modal>
		  </div>` : html``}`;
  return { show, template };
};
